import React, { useEffect, useState } from 'react';
import {
  TUIKit,
  TUIChat,
  TUIMessageInput,
  TUIMessageList,
  TUIChatHeader,
} from '@tencentcloud/chat-uikit-react';
import '@tencentcloud/chat-uikit-react/dist/cjs/index.css';
import { ChatSDK } from 'tim-js-sdk/tim-js-friendship';
import TIM, { GroupMember, Message } from 'tim-js-sdk';

import overlapping from './image/overlapping.png';
import chat from './image/chat.png';
import expand from './image/expand.png';
import giftbox from './image/giftbox.png';
import member from './image/member.png';
import backChat from './image/backChat.png';
import admin from './image/admin.png';
import audience from './image/audience.png';

import './style.scss';

import {
  TUILive,
  TUILiveMemberList,
  TUILiveMemberListItemParams,
} from './TUILive';

import { LiveGift } from './live-gift';
import { LiveMessageProfix } from './live-message-profix';
import { LiveMessageName } from './live-message-name';
import { ANCHOR } from '../../config/tencent';
import { getUrlParam } from '../../utils/utils';
import { STORAGE_NAME } from '../../constants';
import { useMediaQuery } from 'react-responsive';

export default function LiveLayout(props: any) {
  const { groupID, userID, className } = props;

  // group for memeberList
  const memberGroupList: Array<TUILiveMemberListItemParams> = [
    {
      title: (
        <>
          <img className='icon-title' src={admin} alt='' /> Administrator
        </>
      ),
      name: 'Administrator',
      filter: (list: Array<GroupMember>, ownerProfile: GroupMember) => {
        return [ownerProfile];
      },
    },
    {
      title: (
        <>
          <img className='icon-title' src={audience} alt='' /> Audience
        </>
      ),
      name: 'Audience',
      filter: (list: Array<GroupMember>, ownerProfile: GroupMember) => {
        return list || [];
      },
    },
  ];

  // TUIMessage plugin config
  const messagePluginConfig = {
    quote: {
      isShow: false,
    },
    forward: {
      isShow: false,
    },
    revoke: {
      isShow: false,
    },
    delete: {
      isShow: false,
    },
    copy: {
      isShow: false,
    },
  };

  // TUIMessage config
  const messageConfig = {
    className: 'live-message',
    isShowTime: false,
    isShowRead: false,
    isShowPlugin: false,
    plugin: {
      config: messagePluginConfig,
    },
    prefix: <LiveMessageProfix />,
    customName: <LiveMessageName />,
    isShowMyAvatar: true,
  };

  // TUIMessageInput config
  const TUIMessageInputConfig = {
    className: 'live-input',
    pluginConfig: {
      isImagePicker: false,
      isVideoPicker: false,
      isFilePicker: false,
    },
    isTransmitter: true,
  };

  const isMobile = useMediaQuery({ maxWidth: '768px' });
  const [tim, setTim] = useState<ChatSDK>();
  const [isChatShow, setIsChatShow] = useState<boolean>(true);
  const [isMembersShow, setIsMembersShow] = useState<boolean>(false);
  const [customData, setCustomData] = useState(
    JSON.stringify({ mode: 'live', vip: 1 })
  );
  const roleCurrent = getUrlParam('role');
  const [isGiftShow, setIsGiftShow] = useState<boolean>(false);
  const [isShowAction, setIsShowAction] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      if (props?.tim && !tim) {
        const { tim } = props;
        await searchGroup(tim);
        setTim(tim);
      }
    })();
  });

  // open / close chat module
  const toggleChat = () => {
    setIsChatShow((prevState) => !prevState);
    setIsGiftShow(false);
    setIsShowAction(false);
    // setIsMembersShow(false);
  };

  //  open / close memberList module
  const toggleMemberList = () => {
    setIsMembersShow(!isMembersShow);
  };

  // gift callback
  const handleTUIGift = (level: number) => {
    const data = JSON.parse(customData);
    data.vip = level;
    setCustomData(JSON.stringify(data));
  };

  const createGroup = async (tim: any) => {
    try {
      const roomName = localStorage.getItem(`ROOM_NAME`)
        ? JSON.parse(localStorage.getItem(`ROOM_NAME`) || '').find((item: any) => item.roomId == groupID).name
        : `Room ${groupID}`
      await tim.createGroup({
        type: TIM.TYPES.GRP_AVCHATROOM,
        name: roomName,
        groupID: `${groupID}`,
      });

    } catch (imError) {
      console.error('createGroup error:', imError);
      // this.$message.error(`创建群组失败的相关信息`);
    }
  };

  const joinGroup = async (tim: any) => {
    try {
      await tim.joinGroup({
        groupID: `${groupID}`,
        type: TIM.TYPES.GRP_AVCHATROOM,
      });
    } catch (error) {
      console.error('joinGroup error:', error);
    }
  };

  const searchGroup = async (tim: any) => {
    try {
      await tim.searchGroupByID(`${groupID}`);

      // Update user profile
      if (
        localStorage.length &&
        localStorage.getItem(STORAGE_NAME.CURRENT_USER_PROFILE)
      ) {
        const dataUser = JSON.parse(
          localStorage.getItem(STORAGE_NAME.CURRENT_USER_PROFILE) || ``
        );
        await tim.updateMyProfile({
          nick: dataUser.name,
        });
      }

      await joinGroup(tim);
    } catch (imError) {
      console.warn('searchGroupByID error:', imError);
      if (roleCurrent === ANCHOR) {
        await createGroup(tim);
        await joinGroup(tim);
      }
    }
  };

  return (
    <div className={`live ${className}`}>
      <TUIKit tim={tim}>
        <TUILive
          tim={tim}
          className='live-player'
          menuIcon={
            !isChatShow ? (
              <img
                className='icon icon-expand'
                src={expand}
                alt='Expand'
                onClick={toggleChat}
              />
            ) : (
              <></>
            )
          }
          groupID={groupID}
          memberGroupList={memberGroupList}
          setIsChatShow={setIsChatShow}
          setIsGiftShow={setIsGiftShow}
          setIsShowAction={setIsShowAction}
          isShowAction={isShowAction}
        ></TUILive>

          <TUIChat
            className={`live-chat ${!isChatShow && 'live-none'}`}
            cloudCustomData={customData}
            messageConfig={messageConfig}
            TUIMessageInputConfig={TUIMessageInputConfig}
          >
            <TUIChatHeader
              title='Live Chat'
              avatar={
                <img
                  className='icon icon-overlapping'
                  src={overlapping}
                  alt='Overlapping'
                  onClick={toggleChat}
                />
              }
            // headerOpateIcon={<img className='icon icon-member' src={member} alt='member' onClick={toggleMemberList} />}
            />
            {/*{<LiveNotification />} */}
            <TUIMessageList />
            {/* <LiveGift callback={handleTUIGift} /> */}
            <div className='chat-footer' style={{
              height: roleCurrent === ANCHOR ? '104px' : '120px',
              justifyContent: roleCurrent === ANCHOR ? "center" : "flex-start"
            }}>
              <LiveGift
                setIsGiftShow={setIsGiftShow}
                isGiftShow={isGiftShow}
                callback={handleTUIGift}
                groupID={groupID}
                tim={tim}
              />
              <TUIMessageInput />
            </div>
          </TUIChat>


        {isMobile && (
          <div className='chat-gift-mobile'>
            <div
              style={{
                display: 'flex',
              }}
            >
              <img
                className='icon icon-chat'
                src={chat}
                alt='Chat'
                onClick={toggleChat}
              />
              <LiveGift
                setIsChatShow={setIsChatShow}
                setIsGiftShow={setIsGiftShow}
                isGiftShow={isGiftShow}
                callback={handleTUIGift}
                setIsShowAction={setIsShowAction}
                isShowAction={isShowAction}
                groupID={groupID}
                tim={tim}
              />
            </div>
          </div>
        )}
      </TUIKit>
    </div>
  );
}
